"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 默认布局使用的多语言
var _default = {
  'zh-CN': {
    basicLayout: {
      search: {
        placeholder: '搜索...',
        cancel: '取消'
      },
      user: {
        center: '个人中心',
        setting: '设置',
        logOut: '退出登录'
      },
      logout: {
        confirmTitle: '退出登录确认',
        confirmContent: '您确定退出登录当前账户吗？打开的标签页和个人设置将会保存。'
      },
      tabs: {
        left: '关闭左侧',
        right: '关闭右侧',
        other: '关闭其它',
        all: '全部关闭'
      },
      textWriting: {
        greetingTitle: 'Hi,欢迎使用文案创作功能',
        greetingTitleImage: 'Hi,欢迎使用图片创作工具！',
        greetContent: '本平台生成的文案主要是为创作者提供灵感，商用前请务必告知客户具体哪些内容是由AI生成。',
        greetContentImage: '本平台生成的图片主要是为创作者提供灵感，商用前请务必告知客户具体哪些内容是由AI生成。',
        importProduct: '导入产品',
        productImg: '产品图',
        uploadImg: '上传图片',
        uploadImgTip: '提示：支持.jpg.jpeg.png，文件大小不超过20M',
        addImg: '上传图片(提示：支持.jpg.jpeg.png，文件大小不超过3M)',
        addImgImage: '上传图片(提示：支持.jpg.jpeg.png，文件大小不超过20M)',
        brand: '品牌',
        productName: '产品名称',
        addPicture: '添加',
        reqDescribtion: '需求描述',
        scene: '应用场景',
        red: '小红书',
        weibo: '微博',
        generate: '生成',
        complete: '完成',
        export: '导出',
        selectAll: '全部勾选',
        simpleStyle: '简约',
        generateAll: '全部重新生成',
        copy: '复制',
        generateAgain: '重新生成',
        fabulous: '赞',
        dislike: '踩',
        like: '已赞',
        disliked: '已踩',
        styleManagement: '风格管理',
        styleName: '风格名称',
        addStyle: '添加风格',
        submit: '保存',
        cancel: '取消',
        sellingPoints: '产品卖点',
        enterStyleName: '输入风格名称',
        microblogExample: '示例:\n尊贵而追求卓越的奔驰品牌隆重推出：全新奔驰C260。以品牌的卓越工艺和非凡设计，演绎出无与伦比的驾驶体验。C260，长轴距带来的舒适空间，将每一次旅途都变为惬意享受。强劲的动力系统，则铸就了驾驭路上的尊贵之感。舒适、动力、尊贵，一切为了让您领略奔驰的非凡魅力。欢迎您，融入奔驰C260的怀抱，开启尊贵之旅。\n\n#奔驰C260# #尊贵之旅# #驾驭非凡#',
        wechatExample: '示例:\n文章标题： 征服路程，尊崇品味——奔驰C260 助您驰骋之旅\n\n封面配图建议： 一辆闪耀的奔驰C260驶过城市夜晚的街道，灯光映射下流动的线条展现出豪华与动感。\n\n今天，我们荣幸地向您推荐一款令人心动的座驾——奔驰C260。这款车型以其卓越的性能与舒适体验，为您的驾驶之旅注入无限的精彩与尊荣。\n\n动力强悍，尽显非凡\n奔驰C260的强劲动力，如猛兽咆哮般威猛，源自其先进的引擎技术。在每一次踩下油门的瞬间，那股瞬息爆发的动力会将您紧紧贴着座椅，仿佛飞翔的感觉在指尖延伸。不论是城市道路还是高速公路，C260都能迅猛应对，将驾驶的乐趣推向高潮。\n\n配图：奔驰C260的动感线条，彰显出其强劲的动力性能。\n\n轴距长，行程更享受\n拥有宽敞舒适的内部空间是奔驰一贯的追求，而C260毫不例外。其长轴距设计不仅为乘客带来更为宽裕的腿部空间，更为后排乘客创造出恣意舒适的休憩环境。无论是短途出行还是长途旅程，C260都将为您营造出尊贵与宁静的驾乘感受。\n\n油耗低，绿色出行\n奔驰C260在强大动力的同时，并未牺牲燃油经济性。其精湛的动力管理系统，以及先进的节能科技，使得油耗控制在更低的水平。现代社会，环保意识日益增强，C260作为您的行进伙伴，将为您贡献一份绿色、环保的出行方式。\n\n乘坐舒适，尊崇之选\n细致考量每一个细节，奔驰C260为乘客营造出至臻舒适。精选的内饰材质，多功能座椅设计，以及智能化的驾驶辅助系统，将您置身于宾至如归的用车环境中。无论是驾驶还是乘坐，C260都将成为您尊崇品味的象征。\n\n配图：C260的内饰豪华精致，高品质的材质为驾乘增色不少\n\n在行驶的道路上，奔驰C260不仅仅是一款座驾，更是一种生活态度的延伸。豪华与激情，在这里完美融合，为您带来无与伦比的驾驶享受。如果您也渴望掌握时间，尊崇品味，那么C260定会成为您最明智的选择。\n\n配图：C260的智能驾驶辅助系统，为驾驶者带来更安全、便捷的驾驶体验。\n\n欢迎各位车友关注我们的微信公众号，了解更多关于奔驰C260的精彩内容。同时，您的评论与分享将是我们前行的最大动力。在评论区留下您的宝贵意见，让我们更好地为您呈现更多优质文章。与您一同追寻驾驶的乐趣，感受奔驰带来的无限魅力！',
        liveExample: '示例:\n大家瞧一瞧，这就是我手里的明星产品——奔驰C260！🚗💥\n我刚刚给大家简单介绍一下，你有没有被它的炫酷外观和霸气动力给征服呢？别急，我还没说完！\n首先，它的轴距长，乘坐舒适度杠杠的，别说是长途旅行，就算在城市穿梭，也能尽情享受每一段舒适的时光！就像坐在软绵绵的云上一样，惬意到不行！\n而且，咱们不只是追求舒适，还要速度与激情！C260的动力绝对够猛，瞬间爆发，带你一路冲天！踩下油门的瞬间，那种加速感简直让人血脉喷张，我保证，你的心跳会跟着引擎一起飙升！\n别以为动力强就一定燃油大，错了，C260可是油耗低得让你惊讶！这不仅是一辆能带来速度与激情的座驾，还是一个省钱的好伙伴！省下的钱，你可以去做更多更有趣的事情！\n现在，最令人兴奋的时刻来了！**限时促销，下单立减10000元！**是的没错，就是10000元！你没听错，这个价格优惠简直是狂欢！这么超值的优惠，你还犹豫什么？！赶紧在直播间下单，不要再错过这个难得的机会！\n来吧，小伙伴们，一起驾驭C260，体验速度、舒适与省油的完美结合！立即行动，猛戳下方链接，轻松拥有你的梦想座驾！🚗🔥🛒'
      },
      audioWriting: {
        greetingTitle: 'Hi,欢迎使用音频创作工具',
        greetContent: '本平台生成的音频主要是为创作者提供灵感，商用前请务必告知客户具体哪些内容是由AI生成。'
      }
    }
  },
  'en-US': {
    basicLayout: {
      search: {
        placeholder: 'Search...',
        cancel: 'Cancel'
      },
      user: {
        center: 'My home',
        setting: 'Setting',
        logOut: 'Log out'
      },
      logout: {
        confirmTitle: 'Logout confirmation',
        confirmContent: 'Are you sure you are logged out of your current account? Open tabs and personal settings will be saved.'
      },
      tabs: {
        left: 'Close left',
        right: 'Close right',
        other: 'Close other',
        all: 'Close all'
      },
      textWriting: {
        importProduct: 'Import Products',
        productImg: 'Product picture',
        addImg: 'Upload pictures(Prompt: Only jpg and png formats are supported,The file size does not exceed 3M)',
        brand: 'Brand',
        productName: 'Product name',
        addPicture: 'Add picture',
        reqDescribtion: 'Requirements description',
        scene: 'Application scenario',
        red: 'RED',
        generate: 'Generate',
        complete: 'Complete',
        export: 'Export',
        selectAll: 'Select All',
        simpleStyle: 'Simple style',
        generateAll: 'Generate all',
        copy: 'Copy',
        generateAgain: 'Generate again',
        fabulous: 'Fabulous',
        dislike: 'Dislike',
        like: 'Like',
        disliked: 'Disliked',
        styleManagement: 'Style management',
        styleName: 'Style name',
        addStyle: 'Add style',
        submit: 'Submit',
        cancel: 'Cancel',
        sellingPoints: 'Product selling points'
      }
    }
  }
};
exports.default = _default;